import React from 'react';
import { motion } from 'framer-motion';
import ScrollAnimation from './ScrollAnimation';

const Founder = () => (
  <ScrollAnimation>
    <motion.section
      id="about"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h2
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        About Me
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        <p style={{ marginBottom: '1.25rem' }}>
          Hey there! I'm Halil Ibrahim, a solo founder who codes, designs, and ships products from scratch.
          I didn't start with a CS degree or a fancy job at a big tech company. I started with curiosity,
          late nights, and a stubborn belief that if I kept building, something meaningful would click.
        </p>

        <p style={{ marginBottom: '1.25rem' }}>
          My journey began with Harvard's CS50 courses - to break problems
          into pieces, to appreciate the craft of clean code. Since then, I've gone deep: React, Python, APIs
          Django, mobile development, AI integrations. But honestly, the tech is just a vehicle. What I really
          care about is making things that matter to real people.
        </p>

        <p style={{ marginBottom: '1.25rem' }}>
          I believe the best products come from empathy, not ego. From listening, not lecturing. I talk to
          users obsessively, ship fast, measure everything, and stay humble when the data tells me I was wrong.
          That's the mindset I bring to everything I build.
        </p>

        <p style={{ marginBottom: '0' }}>
          Right now, I'm all-in on <strong style={{ color: 'var(--aurora-1)' }}>StylegenAI</strong>. An AI-powered
          mobile app makes easier to getting dressed. It's my first real product, and I'm
          pouring my heart into it. If you're a fellow builder, founder, or just someone who appreciates the grind,
          I'd love to connect.
        </p>
      </motion.div>
    </motion.section>
  </ScrollAnimation>
);

export default Founder;
